import React, { useState, useEffect } from 'react'
import { styled } from "@mui/material/styles";
import '../../superadmin/styles/pages/dashboard.css';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, TextField, Button, InputAdornment, } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CloseIcon from "@mui/icons-material/Close";
import instance from '../../utils/Api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useGlobalContext } from '../../Contex';
import Grid from "@mui/material/Grid2";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Addadmin = ({ setAddadmins, openDialog, setOpenDialog, admin }) => {
    const { buttondisable, setButtondisable } = useGlobalContext();
    const [email, setEmail] = useState();
    const [address, setAddress] = useState();
    const [mobile_no, setMobile_no] = useState();
    const [name, setName] = useState();
    const [password, setPassword] = useState();
    const [id_no, setid_no] = useState();
    const [logo, setLogo] = useState();
    const [showPassword, setShowPassword] = useState(false);


    useEffect(() => {
        if (admin) {
            setEmail(admin.email || '');
            setAddress(admin.address || '');
            setMobile_no(admin.mobile_no || '');
            setName(admin.name || '');
            setid_no(admin.id_no || '');
        } else {
            setEmail('');
            setPassword('');
            setAddress('');
            setMobile_no('');
            setName('');
            setLogo('');
            setid_no('');
        }
    }, [admin]);

    const handleClose = () => {
        setOpenDialog(false);

        //empty value
        if (admin) {
            setEmail(admin.email || '');
            setAddress(admin.address || '');
            setMobile_no(admin.mobile_no || '');
            setName(admin.name || '');
            setid_no(admin.id_no || '');
        } else {
            setEmail('');
            setPassword('');
            setAddress('');
            setMobile_no('');
            setName('');
            setLogo('');
            setid_no('');
        }
    };

    // Email validation function
    const isValidEmail = (email) => {
        // Regex pattern for validating an email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    //add schools api call
    const handleAddadmins = async () => {
        if (!id_no || !id_no.trim()) {
            toast.error('Please enter Id Number');
            return;
        }
        if (!name || !name.trim()) {
            toast.error('Please enter Company Name');
            return;
        }
        if (!email || !email.trim()) {
            toast.error('Please enter Email Id');
            return;
        }
        if (!isValidEmail(email)) {
            toast.error('Please enter a valid email address');
            return;
        }
        if (!mobile_no || !mobile_no.trim()) {
            toast.error('Please enter Mobile Number');
            return;
        }
        if (!address || !address.trim()) {
            toast.error('Please enter Address');
            return;
        }
        if (!password || !password.trim()) {
            toast.error('Please enter Password');
            return;
        }
        if (!logo) {
            toast.error('Please Upload Company Logo');
            return;
        }
        setButtondisable(true);
        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('address', address);
            formData.append('mobile_no', mobile_no);
            formData.append('password', password);
            formData.append('name', name);
            formData.append('logo', logo);
            formData.append('id_no', id_no);
            const response = await instance.post('Admins/AdminSignup', formData);
            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setAddadmins(true);
                setButtondisable(false);
            } else {
                toast.error(response.data.message);
                setButtondisable(false);
            }
        } catch (error) {
            // Check if the error is due to a duplicate product name
            if (error?.response?.data?.error?.includes('E11000 duplicate key error')) {
                toast.error(`Email "${email}" already exists. Please choose a different email.`);
            } else {
                toast.error(error?.response?.data?.message || 'An unexpected error occurred');
            }
            console.log(error.response);
            setButtondisable(false);
        }
    }
    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogo(file);
        }
    };


    //update schools api call
    const handleUpdateadmins = async () => {
        if (!id_no || !id_no.trim()) {
            toast.error('Please enter Id Number');
            return;
        }
        if (!name || !name.trim()) {
            toast.error('Please enter Company Name');
            return;
        }
        if (!email || !email.trim()) {
            toast.error('Please enter Email Id ');
            return;
        }
        if (!isValidEmail(email)) {
            toast.error('Please enter a valid email address');
            return;
        }
        if (!mobile_no || !mobile_no.trim()) {
            toast.error('Please enter Mobile Number');
            return;
        }
        if (!address || !address.trim()) {
            toast.error('Please enter Address');
            return;
        }

        setButtondisable(true);
        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('address', address);
            formData.append('mobile_no', mobile_no);
            formData.append('admin_id', admin?._id);
            formData.append('name', name);
            formData.append('id_no', id_no);
            if (password && password.trim()) {
                formData.append('password', password);
            }
            logo && formData.append('logo', logo)
            const response = await instance.put(`Admins/updateAdmin`, formData);
            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setAddadmins(true); // Trigger refresh after update Admins
                setButtondisable(false);
            } else {
                toast.error(response.data.message);
                setButtondisable(false);
            }
        } catch (error) {
            if (error?.response?.data?.error?.includes('E11000 duplicate key error')) {
                toast.error(`Email "${email}" already exists. Please choose a different email.`);
            } else {
                toast.error(error?.response?.data?.message || 'An unexpected error occurred');
            }
            setButtondisable(false);
        }
    }
    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {admin ? 'Update' : 'Add '} Admin
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section>
                        <div className='add-admin'>
                            <Grid container spacing={2}>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter Id Number'
                                            label='Id Number'
                                            type='text'
                                            fullWidth
                                            required
                                            value={id_no}
                                            onChange={(e) => setid_no(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter Company Name'
                                            label='Company Name'
                                            type='text'
                                            fullWidth
                                            required
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter Email Id'
                                            label='Email'
                                            type='email'
                                            fullWidth
                                            required
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter Mobile Numnber'
                                            label='Mobile Number'
                                            type='number'
                                            fullWidth
                                            required
                                            value={mobile_no}
                                            onChange={(e) => setMobile_no(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter Address'
                                            label='Address'
                                            type='text'
                                            fullWidth
                                            required
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter your Password'
                                            label='Password'
                                            type={showPassword ? 'text' : 'password'}
                                            fullWidth
                                            required={!admin}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <IconButton
                                                            onClick={() => setShowPassword(!showPassword)}
                                                            edge='end'
                                                        >
                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="admin-textfiled">
                                        <label htmlFor="logo-upload" style={{ marginBottom: '8px', display: 'block' }}>
                                            Upload Logo*
                                        </label>
                                        <input
                                            id="logo-upload"
                                            type="file"
                                            accept="image/*"
                                            required
                                            onChange={(e) => handleLogoUpload(e)}
                                            style={{
                                                display: 'block',
                                                width: '100%',
                                                padding: '10px',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                            }}
                                        />
                                    </div>
                                </Grid>

                                {/* <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter the full name'
                                            label='Full name'
                                            type='text'
                                            fullWidth
                                            required />
                                    </div>
                                </Grid> */}
                                {/* <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className='admin-textfiled'>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={age}
                                                label="Gender"
                                                onChange={(e) => setAge(e.target.value)}
                                                required
                                            >
                                                <MenuItem value={10}>Ten</MenuItem>
                                                <MenuItem value={20}>Twenty</MenuItem>
                                                <MenuItem value={30}>Thirty</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid> */}

                            </Grid>
                        </div>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="cancel-btn"
                        onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        className="add-btn" disabled={buttondisable} onClick={admin ? handleUpdateadmins : handleAddadmins}>
                        {admin ? 'Update' : 'Add'}
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Addadmin;

